/**
 * Whether an ISO-shaped date string is today or later, in local time.
 *
 * Compared as day strings rather than timestamps: `Date.parse` reads
 * "2026-09-03" as UTC midnight, already in the past for anyone west of UTC —
 * so `>= Date.now()` would reject *today*. `en-CA` is ISO-shaped in local
 * time, so a plain string comparison works.
 */
export const isTodayOrLater = (value: string): boolean =>
  value.slice(0, 10) >= new Date().toLocaleDateString("en-CA");
